import { memo } from "react";
import { OverflowTooltip } from "@4uhub/lib4uhub";
import { IUsers } from "../EvaluationLogs/model";

interface ITicketMemberProps {
  data: IUsers[];
}
const TicketMembers: React.FC<ITicketMemberProps> = ({ data }) => {
  if (!data || data.length === 0) return <>-</>;

  const membersNames = data.map((member) => member.fullName).join(", ");

  return (
    <OverflowTooltip
      text={membersNames}
      tooltip={membersNames}
      variant="body2"
      textTransform="none"
    />
  );
};

export default memo(TicketMembers);
